import script from "./CartItemControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartItemControls.vue?vue&type=script&setup=true&lang=ts"

import "./CartItemControls.vue?vue&type=style&index=0&id=407fe4e8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-407fe4e8"]])

export default __exports__